<template>
    <div class="">
        <div>
          <el-row>
            <el-col :span="12">
              <h4>Survey Name:</h4>
            </el-col>
            <el-col :span="12">
              <h4>Survey Type:</h4>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <h4>Start Date</h4>
            </el-col>
            <el-col :span="12">
              <h4>End Date</h4>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <h4>Description:</h4>
            </el-col>
          </el-row>
          <el-row>
            <h4>Section A</h4>
          </el-row>
          <el-row>
            <h4>Section B</h4>
          </el-row>
          <el-row>
            <h4>Section C</h4>
          </el-row>
        </div>
        <div class="row" style="margin-left:0px;">
        <el-button class="btn-theme surveyPrev" @click="clickPrev()" style="width:6rem">Previous</el-button>
        <el-button class="btn-theme surveyNext" @click="clickNext()" style="width:6rem; left:20rem;">Next</el-button>
      </div>
    </div>
</template>
<script>
export default {
  data () {
    return {
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      }
    }
  },
  methods: {
    clickPrev () {
      this.$emit('prev', 1)
    },
    clickNext () {
      this.$emit('next', 2)
    }
  }
}
</script>
<style>
.cardCreate {
font-weight: 500;
  font-size: 16px;
  margin-bottom: 0;
  background: white;
  color: #455a64;
  padding: 3rem;
  margin: 3rem;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,1);
}
</style>



// WEBPACK FOOTER //
// src/components/Survey/FinalizeSurvey.vue